import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import useUnarchiveTransactionCategory from '@/services/api/transaction-category/useUnarchiveTransactionCategory'
import {
  ArrowPathRoundedSquareIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid'
import React, { useState } from 'react'

interface UnArchiveTransactionCatrgoryProps {
  id: number
}

export default function UnArchiveTransactionCatrgory({
  id,
}: UnArchiveTransactionCatrgoryProps) {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const { mutate: unarchiveTransactionCategory } =
    useUnarchiveTransactionCategory()

  function unArchive() {
    unarchiveTransactionCategory(id)
    setShowConfirmation(false)
  }

  return (
    <>
      <Dialog open={showConfirmation} onOpenChange={setShowConfirmation}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Unarchive Transaction Category</DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>

          <DialogBody>
            <p>
              Are you sure you want to unarchive this transaction category? Once
              unarchived, it will be available for selection in transactions
              again.
            </p>
          </DialogBody>

          <DialogFooter>
            <Button type="button" variant="destructive" onClick={unArchive}>
              Unarchive
            </Button>

            <DialogClose asChild>
              <Button type="button" variant="secondary">
                Cancel
              </Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              iconOnly
              variant="ghost"
              onClick={() => setShowConfirmation(true)}
            >
              <ArrowPathRoundedSquareIcon />
            </Button>
          </TooltipTrigger>
          <TooltipPortal>
            <TooltipContent align="end">
              Restore
              <TooltipArrow />
            </TooltipContent>
          </TooltipPortal>
        </Tooltip>
      </TooltipProvider>
    </>
  )
}
